import { Component, Input, OnInit } from '@angular/core';

import { ResponseService } from '../../../../../../services/response.service';
import { HtmlService } from '../../../../../../services/html.service';
import { MyModal } from '../../../../../common/my-modal/my-modal.component';

@Component({
    selector: 'hotspot-interaction',
    template: require('./hotspot-interaction.component.html')
})
export class HotspotComponent implements OnInit {

    @Input() interaction: PgRendererDto.InteractionDefinition;

    hotspotInteraction: PgRendererDto.HotspotInteraction;
    srcUrl: string;

    constructor(
        private responseService: ResponseService,
        private htmlService: HtmlService,
        private myModal:  MyModal) {
    }

    ngOnInit() {
        this.hotspotInteraction = this.interaction.HotspotInteraction;
        this.srcUrl = this.htmlService.getResourceUrl(this.hotspotInteraction.ResourceObject.ResourceId);
    }

    toggleHotspot(hotspotChoice: PgRendererDto.HotspotChoice) {
        const isHotspotCurrentlySelected = this.isSelected(hotspotChoice);

        if (!isHotspotCurrentlySelected && this.hotspotInteraction.MaxChoices > 1) {
            const response = this.responseService.getResponse(this.interaction);
            if (response) {
                if (response.Items.length >= this.hotspotInteraction.MaxChoices) {
                    this.myModal.showRegularDlg("Warning", `You may only select ${this.hotspotInteraction.MaxChoices} choices. Please deselect an existing choice to continue.`);
                    return;
                }
            }
        }

        if (this.isSelected(hotspotChoice)) {
            this.responseService.removeResponseItem(this.interaction.InteractionId, hotspotChoice.Identifier);
        } else {
            this.responseService.setResponse(this.interaction, null, hotspotChoice.Identifier, null, this.hotspotInteraction.MaxChoices > 1, null);
        }
    }

    isSelected(hotspotChoice: PgRendererDto.HotspotChoice) {
        return this.responseService.hasResponseItem(this.interaction.InteractionId, hotspotChoice.Identifier);
    }

}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/hotspot-interaction/hotspot-interaction.component.ts